import React from "react";
import { Outlet } from "react-router-dom";

import { AiSideNav } from "@src/components/Navigation/AiSideNav/AiSideNav";

import { AppLayoutShell } from "./layout/AppLayoutShell";

export const AiPageProvider = () => {
  return (
    <AppLayoutShell sideNav={<AiSideNav />} maxWidth="none">
      <Outlet />
    </AppLayoutShell>
  );
};
